import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './Utiles/routes';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "./index.css";

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
